import { generateTypes } from '../../utils/HttpReducerHelper';

export const latestCases = generateTypes('DASHBOARD', 'LATEST_CASES');
